import { styled } from "@mui/material";

export const TechnologyGrid = styled("div")(
  ({ theme }) => `
      display: grid;

      ${theme.breakpoints.up("mobile")} {
        grid-template-columns: repeat(1, 1fr);
        gap: 1rem;
      }

      ${theme.breakpoints.up("tablet")} {
        grid-template-columns: repeat(2, 1fr);
        gap: 1.5rem;

        > div:last-child {
          grid-column: span 2;
        }
      }
`,
);

export const ProblemGrid = styled("div")(
  ({ theme }) => `
      display: grid;

      ${theme.breakpoints.up("mobile")} {
        grid-template-columns: repeat(1, 1fr);
        gap: 1.5rem;
      }

      ${theme.breakpoints.up("tablet")} {
        grid-template-columns: repeat(2, 1fr);
        gap: 1.5rem;

        > div:last-child {
          grid-column: span 2;
        }
      }

      ${theme.breakpoints.up("desktopXl")} {
        grid-template-columns: repeat(2, 1fr);
        gap: 2.5rem;

        > div:last-child {
          grid-column: span 2;
        }
      }
`,
);
